<template>
  <div>
    <el-table
      :data="tableData"
      v-loading="tableLoading"
      element-loading-text="Loading..."
      ref="table"
      :row-key="rowKeyHandler"
    >
      <el-table-column
        prop="NickName"
        label="Nick Name"
        min-width="150"
        align="center"
      />
      <el-table-column
        prop="ScanDate"
        label="Scanned Date"
        min-width="150"
        align="center"
      />
      <el-table-column label="Follow" min-width="150" align="center">
        <template slot-scope="{ row }">
          <el-tag :type="tagTypeParser(!row.Deleted)" effect="dark">
            {{ tagLabelParser(!row.Deleted) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="AcceptedTerms"
        label="Accepted Terms"
        min-width="200"
        align="center"
      >
        <template slot-scope="{ row }">
          <el-tag :type="tagTypeParser(row.AcceptedTerms)" effect="dark">
            {{ tagLabelParser(row.AcceptedTerms) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="AcceptedNewTerms"
        label="Accepted New Terms"
        min-width="200"
        align="center"
      >
        <template slot-scope="{ row }">
          <el-tag :type="tagTypeParserForAcceptedNewTerms(row.AcceptedNewTerms)" effect="dark">
            {{ tagLabelParserForAcceptedNewTerms(row.AcceptedNewTerms) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="Certified" min-width="150" align="center">
        <template slot-scope="{ row }">
          <el-tag
            :type="tagTypeParser(row.AcceptedTerms && row.Active)"
            effect="dark"
          >
            {{ tagLabelParser(row.AcceptedTerms && row.Active) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="Operation" min-width="150" align="center">
        <template slot-scope="{ row }">
          <el-button  type="text" icon="el-icon-delete" size="medium" @click="handleDelete(row)">
            Delete
          </el-button>
          <!-- <OptionMenu icon="iconfont icon-more-menu" iconSize="18"> -->
            <!-- <OptionMenuItem
              icon="iconfont icon-stop"
              :title="`${row.Active ? 'Deactivate' : 'Activate'}`"
              @click="handleDeactivate(row)"
            /> -->
            <!-- <OptionMenuItem
              icon="iconfont icon-stop"
              :title="`${
                row.AcceptedTerms ? 'De-Accept Terms' : 'Accept Terms'
              }`"
              @click="handleDeAcceptTerms(row)"
            /> -->
            <!-- <OptionMenuItem
              icon="el-icon-delete"
              title="Delete"
              @click="handleDelete(row)"
            /> -->
          <!-- </OptionMenu> -->
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: "Certification",
  data() {
    return {
      tableLoading: true,
      tableData: [],
      searchVal: "",
    };
  },
  computed: {
    seId() {
      return this.$route.params.seId;
    },
  },
  created() {
    this.getTableData();
  },
  methods: {
    tagTypeParserForAcceptedNewTerms(flag) {
      return flag=='1' ? "success" : "danger";
    },
    tagLabelParserForAcceptedNewTerms(flag) {
      return flag=='1' ? "Yes" : "No";
    },
    rowKeyHandler(row) {
      return row.WechatSEID;
    },
    onSearch() {
      this.currentPage = 1;
      this.getTableData();
    },
    dateFormatter(row, column, cellValue) {
      return this.moment(new Date(cellValue)).format("YYYY-MM-DD HH:mm:ss");
    },
    tagTypeParser(flag) {
      return flag ? "success" : "danger";
    },
    tagLabelParser(flag) {
      return flag ? "Yes" : "No";
    },
    getTableData() {
      if (!this.seId || this.$route.name === 'sr-menu') {
        this.tableLoading = false;
        this.tableData = [];
        return;
      }
      this.tableLoading = true;
      this.axios
        .get(`/seDetail/viewCert`, {
          params: {
            seId: this.seId,
          },
        })
        .then(({ code, data, msg }) => {
          this.tableLoading = false;
          if (200 === code) {
            this.tableData = data;
          } else {
            this.$message.error(msg);
          }
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
    handleDeactivate(row) {
      this.axios
        .get("/seDetail/activate", {
          params: {
            wechatSeId: row.WechatSEID,
            isActive: !row.Active,
          },
        })
        .then(({ code, msg }) => {
          if (code === 200) {
            this.$message.success(
              `${
                row.Active ? "Deactivate" : "Activate"
              } wechat account successfully`
            );
            this.getTableData();
            this.$emit("success");
          } else {
            this.$message.error(msg);
          }
        });
    },
    handleDeAcceptTerms(row) {
      this.axios
        .get("/seDetail/acceptTerm", {
          params: {
            wechatSeId: row.WechatSEID,
            isAccept: !row.AcceptedTerms,
          },
        })
        .then(({ code, msg }) => {
          if (code === 200) {
            this.$message.success(
              `${
                row.AcceptedTerms ? "De-Accept" : "Accept"
              } user terms successfully`
            );
            this.getTableData();
            this.$emit("success");
          } else {
            this.$message.error(msg);
          }
        });
    },
    handleDelete(row) {
      this.axios
        .get("/seDetail/delete", {
          params: {
            wechatSeId: row.WechatSEID,
          },
        })
        .then(({ code, msg }) => {
          if (code === 200) {
            this.$message.success("Delete wechat account successfully");
            this.getTableData();
            this.$emit("success");
          } else {
            this.$message.error(msg);
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
